import React, { createContext, useContext } from 'react';
import { useNavBadges } from '../hooks/useNavBadges';

const NavBadgeContext = createContext({ badges: {}, refreshBadges: () => {} });

export function NavBadgeProvider({ children }) {
  const { badges, refreshBadges } = useNavBadges();
  return (
    <NavBadgeContext.Provider value={{ badges, refreshBadges }}>
      {children}
    </NavBadgeContext.Provider>
  );
}

export function useNavBadgeContext() {
  return useContext(NavBadgeContext);
}
